export default function BrandingBanner() {
  return (
    <section className="py-16 px-8 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-light text-white mb-16 text-center tracking-[0.2em]">
          Brand Identity & Banners
        </h2>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Card 1 - Top Left */}
          <div className="group">
            <div className="relative overflow-hidden rounded-sm mb-6 w-full h-80">
              <img
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/73682d3175f3e2d745c87b52e3e1abe3.jpeg"
                alt="Beer Campaign Banner"
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-all duration-500 group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]"
              />
            </div>
            <p className="text-white/80 font-light leading-relaxed tracking-wide">
              「スクロールの手を止めさせる、圧倒的な違和感」<br />
              数ある広告の中で埋もれないために、「伝説の解禁」というニュース性と、ビジュアルのインパクトを最優先に構成しました。<br />
              視線の誘導（Zの法則）を意識し、強烈なメインビジュアルから、「飲む前に飲まれるな」という挑発的なコピー、そしてCVボタンへとスムーズに視線が流れるレイアウトに設計しています。<br />
              開発者の持つ「常識を覆すビールを作りたい」という熱い思いを代弁するため、既存のビール広告の清涼感あふれるマナーをあえて破り、ダークファンタジーのような世界観でユーザーの好奇心を刺激するクリエイティブに仕上げました。
            </p>
          </div>

          {/* Card 2 - Top Right */}
          <div className="group">
            <div className="relative overflow-hidden rounded-sm mb-6 w-full h-80">
              <img
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/795c3beb5d17b32b30455bd40d79a36b.jpeg"
                alt="English Learning Campaign"
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-all duration-500 group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]"
              />
            </div>
            <p className="text-white/80 font-light leading-relaxed tracking-wide">
              「英語が話せるようになったら、もっと世界が広がる」<br />
              そんなワクワク感を、この一枚のバナーに込めました。<br />
              一番大切にしたのは「楽しそう！」という直感です。英語学習に対する「勉強」「努力」といった重たいイメージを払拭するため、弾むようなリズム感のあるレイアウトと、春らしい温かな光を感じる色彩にこだわりました。<br />
              このバナーを見た方が、「ちょっとやってみようかな」と前向きな気持ちになれるような、背中を優しく押せるデザインを目指して制作しました。
            </p>
          </div>

          {/* Card 3 - Bottom Left */}
          <div className="group">
            <div className="relative overflow-hidden rounded-sm mb-6 w-full h-80">
              <img
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/24e1818bf95b606308ca1bf52599068b.jpeg"
                alt="Organic Skincare Banner"
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-all duration-500 group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]"
              />
            </div>
            <p className="text-white/80 font-light leading-relaxed tracking-wide">
              「朝の10秒」というスキンケア体験そのものをデザインしました。「素肌が呼吸する」というコピーを軸に、見た瞬間に深呼吸したくなるような、心地よい温度感を大切にしています。<br />
              窓辺の柔らかな自然光を感じさせる写真と、香りが漂うようなアンバーやベージュの配色で、オーガニックな本物感を演出。繊細な明朝体をゆったりと配置し、品格と抜け感を両立させました。忙しい日常の中でふと手が止まり、「今の私にはこれが必要だ」と直感的に感じてもらえるような、静かで強い説得力を込めて制作しました。
            </p>
          </div>

          {/* Card 4 - Bottom Right */}
          <div className="group">
            <div className="relative overflow-hidden rounded-sm mb-6 w-full h-80">
              <img
                src="https://static.readdy.ai/image/5c1a65669a2f23c010bcbbefe6230e88/03e6ab8ea293b0c9dfa407afa7f7bc14.jpeg"
                alt="Accounting Software Banner"
                className="w-full h-full object-cover object-top opacity-80 group-hover:opacity-100 transition-all duration-500 group-hover:scale-105 group-hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]"
              />
            </div>
            <p className="text-white/80 font-light leading-relaxed tracking-wide">
              経理業務の「苦痛」から「解放」への劇的な変化を、一目で伝わる視覚的なストーリーとして表現することに注力しました。<br />
              Beforeのエリアでは暗いトーンと山積みの書類で手入力の圧迫感をリアルに演出。対照的にAfterでは、白とゴールドを基調にすることで、ツール導入後のスムーズで輝かしい未来を描いています。<br />
              単なる機能紹介にとどまらず、ユーザーが手にする「時間的余裕」や「精神的な解放感」までがデザインを通して伝わるよう、配色や光の演出によるコントラストを徹底的に作り込んだ一枚です。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
